'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlotLine3dIcon = function PlotLine3dIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 32 32' }, props),
        _react2.default.createElement('path', { d: 'M21.5 15.625L16.062 14l3.25 5.313zM26 8l-4.5 7.625 2.688.75 1.813-3.063 2.375 4.313-4.188-1.25-4.875 8.313-5.875-9.938-9.125 2.688L10.688 10l2.75 4.75 2.563-.75h.063l-5.375-8.688L.001 18.625h.063l-.063.063 16 8 16-8z' })
    );
};

exports.default = PlotLine3dIcon;